import { registerHandler, Sha256Email } from "../handler";

declare const pintrk: any;

interface PinterestParams {
  planId: string;
  duration: number;
}

const PINTERST_TAG_ID = "2620804621622";
const NOOM_WEIGHT_CONVERSION_EVENT = "checkout";
const NOOM_MOOD_CONVERSION_EVENT = "signup";

function convertToPinConvParam(params: Record<string, any>) {
  const convParam: string[] = [];
  Object.keys(params).forEach((key) => {
    const param = params[key];
    if (param != null && param) {
      convParam.push(`${key}:${param.toString()}`);
    }
  });
  return convParam.join(",");
}

function trackPinterestConversion(order, plan, event) {
  const pinParams: PinterestParams = {
    planId: plan.braintree_id,
    duration: plan.billing_cycle_in_months,
  };
  const convParam = convertToPinConvParam(pinParams);
  pintrk("track", event, {
    value: order.erev_9_months,
    order_quantity: 1,
    currency: "USD",
    order_id: order.subscriptionId,
    conv_param1: convParam,
  });
}

function trackPinterestLead(email: Sha256Email) {
  // Advanced tracking for Pinterest (enables Enhanced Match).
  if (email) {
    pintrk("load", PINTERST_TAG_ID, {
      em: email,
    });
  }
  pintrk("track", "lead");
}

// https://developers.pinterest.com/docs/ad-tools/conversion-tag/
export default function registerHandlers() {
  registerHandler("lead", ({ emailHashes }) => {
    trackPinterestLead(emailHashes.sha256);
  });

  registerHandler("HMLead", ({ emailHashes }) => {
    trackPinterestLead(emailHashes.sha256);
  });

  registerHandler("purchase", ({ order, plan }) => {
    trackPinterestConversion(order, plan, NOOM_WEIGHT_CONVERSION_EVENT);
  });

  registerHandler("HMPurchase", ({ order, plan }) => {
    trackPinterestConversion(order, plan, NOOM_MOOD_CONVERSION_EVENT);
  });
}
